import { render, staticRenderFns } from "./RefereeManage.vue?vue&type=template&id=3c1d747b&scoped=true&"
import script from "./RefereeManage.vue?vue&type=script&lang=js&"
export * from "./RefereeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d747b",
  null
  
)

export default component.exports